import React from 'react';
import LastSlide from '../components/LastSlide';
export default ({isActive}) => {
  return (
    <div className="component last-component hide-overflow">
      <LastSlide isActive={isActive}/>
    </div>
  )
}